import { DatadogLogMetaContext, createDatadogMetaContext } from '@reward-platform/logger/utils'
import { ZodIssue } from 'zod'
import { createDatadogLogger } from '~/utils/logger'
import { isClient } from '~/utils/envChecks'
import { ErrorCode } from './clientErrors'

const DEFAULT_BUSINESS_MESSAGE = 'Something went wrong, please check the details and try again'

export abstract class GenericClientError<E extends Error = Error> extends Error {
  private description: string

  public developerMessage: string

  public businessMessage: string

  public code: string

  public httpStatus?: number

  public validationErrors?: ZodIssue[]

  public originalError?: Error

  public fatal: boolean

  public kind?: string

  constructor(code: ErrorCode, error: E, kind?: string) {
    super()
    this.name = error.name
    this.message = error.message
    this.stack = error.stack
    this.code = error.name
    this.description = code
    this.developerMessage = error.message
    this.businessMessage = DEFAULT_BUSINESS_MESSAGE
    this.fatal = false
    this.kind = kind
  }

  public getErrorContext() {
    return {
      message: this.message,
      stack: this.stack,
      code: this.code,
      description: this.description,
      httpStatus: this.httpStatus,
      originalError: this.originalError,
      developerMessage: this.developerMessage,
      businessMessage: this.businessMessage,
      validationErrors: this.validationErrors,
      kind: this.kind,
    }
  }

  public logToDatadog(meta?: DatadogLogMetaContext, additionalData: object = {}) {
    const metaContext = meta ? createDatadogMetaContext(meta) : {}

    const context = { ...additionalData, ...metaContext, error: this.getErrorContext() }

    const message = `'${this.description}' - ${this.developerMessage}`
    if (isClient()) {
      const browserLogger = createDatadogLogger('client-error-handler', { level: 'error' })

      browserLogger.error(`[ClientError] ${message}`, context, this.originalError)
    }
  }
}
